<script lang="ts" setup>
import checkoutConfig from '@consumer/services/checkoutConfig'
import { formatCurrency } from '@consumer/utils/currency'

onBeforeMount(checkoutConfig.load)
</script>

<template>
  <div class="flex flex-col gap-4">
    <p>The purchase fee covers the costs of hosting and maintaining this service,
      the credit card processing fees, the banking fees, and the cost of redeeming gifts.
      There are no additional fees to recipients, regardless of their redemption choice.
    </p>
    <p>
      Purchase fees are calculated for <b>each gift</b> in an order.
    </p>
    <h3 class="text-lg">
      Fee Schedules
    </h3>
    <GDetailsToggle
      size="medium"
      openLabel="Purchase Fees"
      closeLabel="Hide Purchase Fees"
    >
      <div>
        <p class="mb-2">Below is the <b>per gift</b> purchase fee schedule:</p>

        <table class="w-full">
          <tr v-for="(giftFeeScheduleItem, idx) in checkoutConfig.giftFeeSchedule" :key="idx">
            <td>
              <span>{{ formatCurrency(giftFeeScheduleItem.min) }}</span>
              <span v-if="giftFeeScheduleItem.max"> - {{ formatCurrency(giftFeeScheduleItem.max) }}</span>
              <span v-else> and up</span>
            </td>
            <td>
              {{ formatCurrency(giftFeeScheduleItem.fee) }}
            </td>
          </tr>
        </table>
      </div>
    </GDetailsToggle>

    <GDetailsToggle
      size="medium"
      openLabel="Greeting Card Fees"
      closeLabel="Hide Greeting Card Fees"
    >
      <div>
        <table>
          <tbody>
            <tr>
              <td>Premium Greeting Card Design</td>
              <td>$1</td>
            </tr>
          </tbody>
        </table>
      </div>
    </GDetailsToggle>

    <GDetailsToggle
      size="medium"
      openLabel="Shipping Fees"
      closeLabel="Hide Shipping Fees"
    >
      <div>
        <p class="mb-2">Only applies when selecting Mail Delivery:</p>
        <table>
          <tbody>
            <tr><td>First-Class Mail without Tracking</td><td>$5</td></tr>
            <tr><td>First-Class Mail with Tracking</td><td>$8</td></tr>
            <tr><td>Priority Mail with Tracking</td><td>$12</td></tr>
          </tbody>
        </table>
      </div>
    </GDetailsToggle>
  </div>
</template>

<style lang="scss" scoped>
table {
  @apply w-full;
  @apply border-solid border-1 border-grey-400;

  td {
    @apply py-2 px-3;
  }

  td:nth-child(2) {
    text-align: right;
  }

  tr:nth-child(even) {
    @apply bg-grey-300;
  }
}
</style>
